import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';

import { showLoading, hideLoading } from "react-redux-loading-bar";
import { showInfoBox, hideInfoBox } from "../../components/InfoBox/actions.js";

import LaddaButton, { S, SLIDE_UP } from 'react-ladda'

import Paginator from '../../components/paginator/index.js';

import FilePicker from '../../components/FilePicker/index.js';

import PorletRoutesWidget from "../components/PorletRoutesWidget/index.js";

import { post_UpdatePortletForm, post_UpdatePortletFile } from "../../config/urls.js";

import { generateErrorContent } from "../../utils/errorProcessor.js";

import './index.css';
class PortletUpdatePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      zipFile: null,
      addingPortlet_zip: false,
      portletName: props.editPortletData.name,
      portletId: props.editPortletData.portletId,
      portletIsSpa: props.editPortletData.spa,
      portletFormParams: null,

      portletFormShowError: false,

      addingPortlet_form: false,

      zipSectionActive: props.editPortletData.spa ? true : false

    }

    let params = JSON.parse(JSON.stringify(props.editPortletData));
    delete params.portletId;
    delete params.createdOn;
    delete params.updatedOn;

    this.state.portletFormParams = props.editPortletData;

    this.returnToPortletList = this.returnToPortletList.bind(this);

    this.handleFileChange = this.handleFileChange.bind(this);


    this.handleChane_portletForm_name = this.handleChane_portletForm_name.bind(this);
    this.handleChane_portletForm_spa = this.handleChane_portletForm_spa.bind(this);
    this.handleChane_portletForm_indexPath = this.handleChane_portletForm_indexPath.bind(this);
    this.handleChane_portletForm_thumbnail = this.handleChane_portletForm_thumbnail.bind(this);
    this.handleChane_portletForm_layout__showHeader = this.handleChane_portletForm_layout__showHeader.bind(this);

    this.addRouteHandler = this.addRouteHandler.bind(this);
    this.deleteRouteHandler = this.deleteRouteHandler.bind(this);
    this.updateRouteHandler = this.updateRouteHandler.bind(this);



    this.updatePortlet_zip = this.updatePortlet_zip.bind(this);
    this.updatePortlet_form = this.updatePortlet_form.bind(this);
    this.validateFormParams = this.validateFormParams.bind(this);

    this.setTabVal = this.setTabVal.bind(this);
  }


  render() {

    if (!this.state.portletName) {
      const hist = this.props.history;
      hist.push('/portlets')

      return null;
    }

    let zip_section_class = 'zip_section';
    !this.state.zipSectionActive ? zip_section_class += ' hidden_section' : null;

    let form_section_class = 'form_section';
    this.state.zipSectionActive ? form_section_class += ' hidden_section' : null;
    this.state.portletFormShowError ? form_section_class += ' error' : null;

    return (
      <div className="portlets_route_wrapper update">

        <div className="navbar_root">

          <div className="aligner"></div>

          <div className="icon" onClick={this.returnToPortletList} >{backIcon}</div>

          <div className="route_title">Update Portlet</div>

          <div className="profile_controls_wrapper"></div>

        </div>


        <div className="elevated_container">

          <div className="elevated_header">
            <div className="title">
              <div className="top">Update Portlet {this.state.portletName}</div>
              <div className="bot">You can update a portlet by uploading a zip or fill neccessary details to add a new portlet to portal</div>
            </div>
          </div>

          <div className="elevated_content">


            <div className="tab_control">


              {this.state.portletIsSpa && (
                <div id="zip_option" className="option">
                  <div onClick={() => { this.setTabVal(true) }} className={this.state.zipSectionActive ? 'rad active' : 'rad'}><div></div></div>
                  <div className="label">Update Portlet via .zip file</div>
                </div>
              )}

              <div id="form_option" className="option">
                <div onClick={() => { this.setTabVal(false) }} className={!this.state.zipSectionActive ? 'rad active' : 'rad'}><div></div></div>
                <div className="label">Update Portlet by filling the form below</div>
              </div>

            </div>


            <div className={zip_section_class}>


              <div className="info">
                Provide a zip file containing your application files and configuration details. View the <a href="http://google.com" target="_blank">spec here</a> for more details.
              </div>

              <div>
                <FilePicker onChange={this.handleFileChange} />
              </div>

              <div className="submit_area">
                <LaddaButton
                  loading={this.state.addingPortlet_zip}
                  onClick={this.updatePortlet_zip}
                  data-color="blue"
                  data-size={S}
                  data-style={SLIDE_UP}
                  data-spinner-size={30}
                  data-spinner-color="#ddd"
                  data-spinner-lines={12}
                >
                  Submit Request
                </LaddaButton>
              </div>

            </div>


            <div className={form_section_class}>

              <div className="info">
                Fill out the form below to update the portlet.
              </div>

              <div className="fields_area">


                <div className="form_entries_container">

                  <div className={this.state.portletFormParams.name ? 'form_entry' : 'form_entry error'}>
                    <label>Display Name</label>
                    <input
                      id="update_param_name"
                      value={this.state.portletFormParams.name}
                      onChange={this.handleChane_portletForm_name}
                    ></input>
                  </div>


                  <div className={this.state.portletFormParams.indexPath ? 'form_entry' : 'form_entry error'}>
                    <label>Index Path</label>
                    <input
                      id="update_param_indexPath"
                      value={this.state.portletFormParams.indexPath}
                      onChange={this.handleChane_portletForm_indexPath}
                    ></input>
                  </div>

                </div>


                <div className="form_entries_container">

                  <div className={this.state.portletFormParams.thumbnail ? 'form_entry' : 'form_entry error'}>
                    <label>Path to thumbnail</label>
                    <input
                      id="update_param_thumbnail"
                      value={this.state.portletFormParams.thumbnail}
                      onChange={this.handleChane_portletForm_thumbnail}
                    ></input>
                  </div>

                  <div className='form_entry'>
                    <label>Show Header</label>
                    <select id="update_param_showHeader" value={this.state.portletFormParams.layout.showHeader} onChange={this.handleChane_portletForm_layout__showHeader}>
                      <option value={false}>No</option>
                      <option value={true}>Yes</option>
                    </select>
                  </div>

                </div>


                <div className="form_entries_container">

                  {/* <div className='form_entry'>
                    <label>Single Page App</label>
                    <select id="update_param_spa" value={this.state.portletFormParams.spa} onChange={this.handleChane_portletForm_spa}>
                      <option value={false}>No</option>
                      <option value={true}>Yes</option>
                    </select>
                  </div> */}

                  {/* <div className='form_entry'>
                    <label>Show Header</label>
                    <select id="update_param_showHeader" value={this.state.portletFormParams.layout.showHeader} onChange={this.handleChane_portletForm_layout__showHeader}>
                      <option value={false}>No</option>
                      <option value={true}>Yes</option>
                    </select>
                  </div> */}

                </div>

              </div>



              <div className="table_area">
                <PorletRoutesWidget
                  data={this.state.portletFormParams.routes}
                  addRouteHandler={this.addRouteHandler}
                  deleteRouteHandler={this.deleteRouteHandler}
                  updateRouteHandler={this.updateRouteHandler}
                  error={this.state.portletFormShowError}
                />
              </div>

              <div className="submit_area">
                <LaddaButton
                  loading={this.state.addingPortlet_form}
                  onClick={this.updatePortlet_form}
                  data-color="blue"
                  data-size={S}
                  data-style={SLIDE_UP}
                  data-spinner-size={30}
                  data-spinner-color="#ddd"
                  data-spinner-lines={12}
                >
                  Submit Request
                </LaddaButton>
              </div>

            </div>


          </div>

        </div>
      </div>
    );
  }

  returnToPortletList() {
    const hist = this.props.history;
    hist.push('/portlets')
  }

  handleFileChange(valueObj) {
    this.setState({
      zipFile: valueObj
    });
  }



  /////////////////////////////////////////////////////////////////
  //FORM PARAM HANDLERS////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////

  handleChane_portletForm_name(e) {
    let val = e.target.value;

    let portletFormParams = this.state.portletFormParams;
    portletFormParams.name = val;

    this.setState({
      portletFormParams: portletFormParams
    });
  }


  handleChane_portletForm_spa(e) {
    let val = e.target.value;

    let portletFormParams = this.state.portletFormParams;
    portletFormParams.spa = val;

    this.setState({
      portletFormParams: portletFormParams
    });
  }

  handleChane_portletForm_indexPath(e) {
    let val = e.target.value;

    let portletFormParams = this.state.portletFormParams;
    portletFormParams.indexPath = val;

    this.setState({
      portletFormParams: portletFormParams
    });
  }

  handleChane_portletForm_thumbnail(e) {
    let val = e.target.value;

    let portletFormParams = this.state.portletFormParams;
    portletFormParams.thumbnail = val;

    this.setState({
      portletFormParams: portletFormParams
    });
  }

  handleChane_portletForm_layout__showHeader(e) {
    let val = e.target.value;

    let portletFormParams = this.state.portletFormParams;

    let newVal = {
      showHeader: val
    };

    portletFormParams.layout = newVal;

    this.setState({
      portletFormParams: portletFormParams
    });
  }

  /////////////////////////////////////////////////////////////////



  /////////////////////////////////////////////////////////////////
  //ROUTE ENTRIES MANIPULATION/////////////////////////////////////
  /////////////////////////////////////////////////////////////////

  addRouteHandler() {
    let portletFormParams = this.state.portletFormParams;

    let routeList = portletFormParams.routes;

    routeList = this.state.portletFormParams.routes.slice();
    routeList.push({
      id: '',
      route: '',
      url: '',
      stripPrefix: false
    });

    portletFormParams.routes = routeList;

    this.setState({
      portletFormParams: portletFormParams
    });
  }

  updateRouteHandler(index, val) {
    let portletFormParams = this.state.portletFormParams;
    let routeList = portletFormParams.routes;

    routeList[index] = val;

    portletFormParams.routes = routeList;

    this.setState({
      portletFormParams: portletFormParams
    });
  }

  deleteRouteHandler(index) {
    let portletFormParams = this.state.portletFormParams;

    let routeList = portletFormParams.routes;
    routeList.splice(index, 1);

    //yes i know
    portletFormParams.routes = routeList;

    this.setState({
      portletFormParams: portletFormParams
    });
  }

  /////////////////////////////////////////////////////////////////




  /////////////////////////////////////////////////////////////////
  //SUBMIT HANDLERS////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////
  updatePortlet_zip() {
    if (!this.state.zipFile) {
      return;
    }

    this.setState({ addingPortlet_zip: true }, () => {


      let zipFile = this.state.zipFile;

      let formData = new FormData();
      formData.append('portletFile', zipFile.file);

      let portletId = this.state.portletId;

      const requestTool = axios.create({
        timeout: 60000,
        headers: {
          // 'Content-Type': 'multipart/form-data'
        }
      });

      requestTool.post(post_UpdatePortletFile(portletId), formData)
        .then((res) => {
          this.props.hideLoading();
          this.props.showInfoBox('Portlet updated successfully', 'success', 5000);

          const hist = this.props.history;
          hist.replace('/portlets/');
        })
        .catch((err) => {
          this.props.hideLoading();

          this.props.showInfoBox(generateErrorContent(err), 'error', 15000);

          this.setState({ addingPortlet_zip: false });
        })

    })
  }

  updatePortlet_form() {
    let formValid = this.validateFormParams();

    if (!formValid) {
      this.setState({
        portletFormShowError: true
      });
      return;
    }


    this.props.showLoading();
    const requestTool = axios.create({
      timeout: 60000,
      headers: {
      }
    });

    let params = this.state.portletFormParams;

    let portletId = this.state.portletId;

    this.setState({ addingPortlet_form: true }, () => {
      requestTool.post(post_UpdatePortletForm(portletId), params)
        .then((res) => {
          this.props.hideLoading();
          this.props.showInfoBox('Portlet updated successfully', 'success', 5000);

          const hist = this.props.history;
          hist.replace('/portlets/');

        })
        .catch((err) => {
          this.props.hideLoading();

          this.props.showInfoBox(generateErrorContent(err), 'error', 15000);

          this.setState({ addingPortlet_form: false });
        });
    });

  }

  validateFormParams() {

    let portletFormParams = this.state.portletFormParams;

    let name = portletFormParams.name;
    let appId = portletFormParams.appId;
    let indexPath = portletFormParams.indexPath;
    let thumbnail = portletFormParams.thumbnail;

    if (!name || !appId || !indexPath || !thumbnail) {
      return false;
    }

    let routes = portletFormParams.routes;

    // if (routes.length < 1) {
    //   return false;
    // }

    for (let i = 0; i < routes.length; i++) {
      let entry = routes[i];

      if (!entry.id || !entry.route || !entry.url) {
        return false;
      }
    }

    return true;
  }

  /////////////////////////////////////////////////////////////////
  setTabVal(val) {
    this.setState({
      zipSectionActive: val
    });
  }

}





const mapStateToProps = (state) => {
  return {
    editPortletData: state.editPortletData
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),

    showInfoBox: (message, type, timeout) => dispatch(showInfoBox(message, type, timeout)),
    hideInfoBox: () => dispatch(hideInfoBox())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PortletUpdatePage));





const backIcon = (
  <svg x="0px" y="0px" viewBox="0 0 492 492">
    <g>
      <g>
        <path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12    C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084    c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864    l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z" />
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/routes/portlet_update/index.js